import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.currency.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.currency.actionsLoading;
export const getItems = (state:RootState) => state.currency.items;
export const getItemsSelect = (state:RootState) => state.currency.dropDownItems;
export const getItemsCount = (state:RootState) => state.currency.itemsCount;
export const getItemForEdit = (state:RootState) => state.currency.itemForEdit;
export const getError = (state:RootState) => state.currency.error;
export const getErrorAction = (state:RootState) => state.currency.errorAction;
export const validationErrors = (state:RootState) => state.currency.validationErrors;
